module.exports = __webpack_public_path__ + "static/media/profile-pic.fc71fb37.png";